<ng-container *transloco="let t;">
  <div class="p-grid">
    <div class="p-col-6">
      <h2>{{ t('common.labels.onlinetests') }}</h2>
    </div>
    <div class="p-col-6 p-text-right">
    </div>
  </div>

  <p-table [value]="partner.onlinetests">
    <ng-template pTemplate="header">
      <tr>
        <th>{{ t('common.labels.onlinetest') }}</th>
        <th>{{ t('common.labels.public_name') }}</th>
        <th>{{ t('onlinetest_basedata.for_ac') }}</th>
        <th>{{ t('onlinetest_basedata.for_toolbox') }}</th>
        <th>{{ t('onlinetest_basedata.api_active') }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-onlinetest>
      <tr (click)="onOpen(onlinetest)" (keyup.enter)="onOpen(onlinetest)" hoverOnRight="admin.onlinetest.show" tabindex="0">
        <td><p>{{ onlinetest.name }}</p></td>
        <td><p>{{ onlinetest.public_name }}</p></td>
        <td><p [innerHTML]="onlinetest.for_ac | isChecked"></p></td>
        <td><p [innerHTML]="onlinetest.for_toolbox | isChecked"></p></td>
        <td><p [innerHTML]="onlinetest.api_active | isChecked"></p></td>
      </tr>
    </ng-template>
  </p-table>
</ng-container>
